
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { SubscriptionOverview } from "@/components/admin/SubscriptionOverview";
import { BillsOverview } from "@/components/admin/BillsOverview";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

const Subscriptions = () => {
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'subscriptions';
  const [statusFilter, setStatusFilter] = useState<string | null>(searchParams.get('status'));

  // Effect to update statusFilter when URL params change
  useEffect(() => {
    const currentStatus = searchParams.get('status');
    if (currentStatus) {
      setStatusFilter(currentStatus);
    }
  }, [searchParams]);

  // Add cleanup on route change/unmount
  useEffect(() => {
    return () => {
      document.body.style.removeProperty('pointer-events');
    };
  }, []);

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-100">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-12">
              <h1 className="text-4xl font-bold" style={{ color: "#008169" }}>
                Subscriptions
              </h1>
              <p className="text-xl text-gray-600 mt-2">
                Monitor user subscriptions
              </p>
            </div>
            <Tabs defaultValue={defaultTab} className="space-y-4">
              <TabsList>
                <TabsTrigger value="subscriptions">Subscriptions</TabsTrigger>
                <TabsTrigger value="bills">Bills</TabsTrigger>
              </TabsList>
              <TabsContent value="subscriptions" className="space-y-4">
                <SubscriptionOverview />
              </TabsContent>
              <TabsContent value="bills" className="space-y-4">
                <BillsOverview initialFilter={statusFilter} />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default Subscriptions;
